module.exports = __webpack_public_path__ + "static/img/2_11.9c671c44.jpg";